<template>
  <div :class="modalClass + 'modal'">
    <p class="sm-text-white">{{ msg }}</p>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    msg: {
      type: String,
      default: "",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalClass() {
      return this.isActive ? "modal-active " : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/Modal";
</style>
